const ROUTES = {
    commercial: {
        add: "/add-commercial-space",
        listing: "/my-commercial-spaces",
        label: "Commercial Space"
    },
    stall: {
        add: "/add-stall",
        listing: "/my-stalls",
        label: "Stall"
    },
    franchise: {
        add: "/add-franchise",
        listing: "/my-franchises",
        label: "Franchise"
    },
    business: {
        add: "/add-business",
        listing: "/my-businesses",
        label: "Business"
    },
    ads: {
        add: "/add-ads",
        listing: "/my-ads",
        label: "Ad"
    }
};

export default ROUTES;